module.exports = __webpack_public_path__ + "img/159.c093c250.png";